import styled from 'styled-components';

import { CONTAINER_MAX } from '@/constants/breakpoints';
import { flexBetween, flexColumn } from '@/styles/common';

export const Wrapper = styled.div<{
  $isSelected: boolean;
  $hasError?: boolean;
}>`
  position: relative;
  width: 320px;
  max-height: 341px;
  border: 1px solid
    ${({ $hasError, $isSelected }) =>
      $hasError
        ? 'var(--system-red)'
        : $isSelected
          ? 'var(--textAndLabels-main)'
          : 'var(--border-secondary)'};
  border-radius: 28px;
  background: var(--bg-main);
  cursor: pointer;
  ${flexColumn};

  @media (max-width: ${CONTAINER_MAX.desktop}) {
    width: 100%;
  }
`;

export const Header = styled.div<{ $isSelected: boolean }>`
  padding: 30px 20px 16px;
  background: ${({ $isSelected }) =>
    $isSelected ? 'var(--textAndLabels-bump)' : 'transparent'};
  border-radius: 28px 28px 0 0;
  color: var(--textAndLabels-main);
  border-bottom: 1px solid var(--border-secondary);
  flex-shrink: 0;
  width: 100%;
  text-align: left;

  @media (max-width: ${CONTAINER_MAX.tablet}) {
    padding: 24px 20px 16px;
  }
`;

export const TitleWrapper = styled.div`
  ${flexBetween};
  margin-bottom: 20px;
  width: 100%;

  @media (max-width: ${CONTAINER_MAX.tablet}) {
    margin-bottom: 0;
  }
`;

export const RightSectionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const ContentWrapper = styled.div`
  padding: 20px 16px 30px;
  ${flexColumn};
  gap: 20px;
  flex-grow: 1;
  text-align: left;
`;

export const DescriptionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  & svg {
    color: #6a85ff;
  }
`;

export const PopularChoice = styled.div`
  padding: 5px 10px;
  width: fit-content;
  border-radius: 16px;
  background: #dcfad0;
  margin-top: auto;
  color: #4ebe6f;
`;

export const Label = styled.div`
  position: absolute;
  top: -12px;
  right: 16px;
  padding: 5px 10px;
  width: fit-content;
  border-radius: 16px;
  background: #f79cff;
  color: var(--textAndLabels-main);
  z-index: 1;
`;
